import { sendGAEvent } from '@noths/polaris-client-google-analytics';
import { EventsMap } from '@noths/polaris-client-next-redux';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { actions } from 'src/redux/deliveryZoneOptions';
import { DeliveryAreaLocationSelection } from './events';

export const GAEventsMap: EventsMap<ReduxApplicationState> = {
  [actions.setSelectedCountry.type]: (state, __, action) => {
    const { payload } = action as ReturnType<typeof actions.setSelectedCountry>;

    if (typeof payload === 'object') {
      const { selectedCountry, selectedZone } = state.deliveryZoneOptions;
      const fromLocation = `${selectedCountry} - ${selectedZone}`;
      const toLocation = `${payload.selectedCountry} - ${payload.selectedZone}`;

      sendGAEvent<DeliveryAreaLocationSelection>({
        event: 'custom_event',
        event_action: 'Change delivery location',
        event_category:
          payload.sectionParent === 'delivery-area' ? 'Delivery & Returns' : 'Delivery summary',
        event_label: `FROM: ${fromLocation} TO: ${toLocation}`,
      });
    }
  },
};
